<div
  *ngIf="!!orderItem"
  class="split-card_wrapper"
  [class.is-touch]="platformService?.isTouchExperience$ | async"
  [class.split-card-critical_wrapper]="hasCriticalError"
>
  <ion-card
    class="split-card_content split-card_product-message split-card_oos"
    data-cy="split-product-card"
  >
    <div class="error-message" data-cy="split-product-message">
      <ion-icon
        name="alert-circle-outline"
        class="icon_alert-dark"
        data-cy="split-product-close-icon"
      >
      </ion-icon>
      <p>{{ orderItem.orderItemErrorMsg || orderHeaderErrorMsg }}</p>
    </div>

    <div class="inner-card_content">
      <div class="inner-card_text">
        <div>
          <div class="brand" data-cy="split-product-brand-text">
            {{ orderItem.brand }}
          </div>
          <div class="description" data-cy="split-product-description-text">
            {{ orderItem.productDesc }}
          </div>
          <div class="other-product-info" data-cy="split-product-num-text">
            #{{ orderItem.productNumber }}
            <span *ngIf="!!orderItem.packSize" class="mini-border">|</span>
            {{ orderItem.packSize }}
          </div>
          <div
            class="other-product-info-qty"
            data-cy="split-product-cases-eaches-text"
          >
            <span>{{ orderItem.originalUnits }} CS</span>
            <span *ngIf="orderItem.breakable" class="mini-border">|</span>
            <span *ngIf="orderItem.breakable"
              >{{ orderItem.originalEaches }} EA</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="tags" data-cy="split-product-tags">
      <app-usf-chip
        *ngIf="orderItem.directEligible"
        [type]="vendorDirectTag.type"
        [clickable]="vendorDirectTag.clickable"
        [iconConfig]="vendorDirectTag.iconConfig"
        [iconUrl]="vendorDirectTag.iconUrl"
      ></app-usf-chip>
      <app-usf-chip *ngIf="orderItem.mslIndicator">
        {{ 'i18n.productDetail.status.onMasterList' | translate }}
      </app-usf-chip>
      <app-usf-chip *ngIf="orderItem.locallySourceIndicator">
        {{ 'i18n.productDetail.status.locallySource' | translate }}
      </app-usf-chip>
      <app-usf-chip
        *ngIf="contractTag"
        [type]="contractTag.type"
        [iconConfig]="contractTag.iconConfig"
        [iconUrl]="contractTag.iconUrl"
      >
      </app-usf-chip>
    </div>
  </ion-card>

  <ion-card
    *ngIf="orderItem.subOrReplacementProduct; let subOrReplacementProduct"
    class="split-card_content split-card_product-message split-card_in-stock"
  >
    <!--ERROR HEADER AND QUANTITY EXCEPTIONS-->
    <div
      class="error-message error-message_green"
      data-cy="split-product-message-text"
    >
      <ion-icon
        name="sync"
        data-cy="alternative-type-label-icon"
        class="icon_alert-green"
      ></ion-icon>
      {{
        (orderItem.orderItemErrorCode !== ErrorTypeEnum.CRITICAL_ERROR_1003
          ? 'i18n.productDetail.replacement.suggestedSubstitute'
          : 'i18n.productDetail.replacement.replacementSubstitute'
        ) | translate
      }}
    </div>

    <div class="inner-card_content">
      <div class="inner-card_text">
        <div>
          <div class="brand" data-cy="split-product-brand-text">
            {{ subOrReplacementProduct.brand }}
          </div>
          <div class="description" data-cy="split-product-description-text">
            {{ subOrReplacementProduct.productDesc }}
          </div>
          <div class="other-product-info" data-cy="split-product-number-text">
            #{{ subOrReplacementProduct.productNumber }}
            <span *ngIf="!!subOrReplacementProduct.packSize" class="mini-border"
              >|</span
            >
            {{ subOrReplacementProduct.packSize }}
          </div>
        </div>
        <div *ngIf="platformService?.isTouchExperience$ | async">
          <ion-icon name="close-circle" class="icon-close" (click)="remove()">
          </ion-icon>
        </div>
      </div>

      <div class="quantity_container">
        <!-- QUANTITIES FIELDS -->
        <div class="quantity_inner-container">
          <div class="quantity_single-wrapper">
            <div class="quantity_single-inner-wrapper">
              <app-import-order-quantity-input
                [productNumber]="subOrReplacementProduct.productNumber"
                [quantity]="unitsOrdered"
                [isEaches]="false"
                [isDisabled]="disabledQuantities"
                (quantityUpdateEmitter)="quantityEmitter.emit($event)"
              >
              </app-import-order-quantity-input>
            </div>
            <div class="quantity-text">CS</div>
          </div>
          <div
            class="quantity_single-wrapper"
            [hidden]="!subOrReplacementProduct.breakable"
          >
            <div class="quantity_single-inner-wrapper">
              <app-import-order-quantity-input
                [productNumber]="subOrReplacementProduct.productNumber"
                [quantity]="eachesOrdered"
                [isEaches]="true"
                [isDisabled]="disabledQuantities"
                (quantityUpdateEmitter)="quantityEmitter.emit($event)"
              >
              </app-import-order-quantity-input>
            </div>
            <div class="quantity-text">EA</div>
          </div>
        </div>
      </div>

      <div *ngIf="(platformService?.isTouchExperience$ | async) === false">
        <ion-icon
          name="close-circle"
          class="icon-close"
          data-cy="split-product-close-icon"
          (click)="remove()"
        >
        </ion-icon>
      </div>
    </div>
    <div class="tags" data-cy="split-product-tags">
      <app-usf-chip
        *ngIf="subOrReplacementProduct.directEligible"
        [type]="vendorDirectTag.type"
        [clickable]="vendorDirectTag.clickable"
        [iconConfig]="vendorDirectTag.iconConfig"
        [iconUrl]="vendorDirectTag.iconUrl"
      ></app-usf-chip>
      <app-usf-chip *ngIf="subOrReplacementProduct.mslIndicator">
        {{ 'i18n.productDetail.status.onMasterList' | translate }}
      </app-usf-chip>
      <app-usf-chip *ngIf="subOrReplacementProduct.locallySourceIndicator">
        {{ 'i18n.productDetail.status.locallySource' | translate }}
      </app-usf-chip>
      <app-usf-chip
        *ngIf="contractTag"
        [type]="contractTag.type"
        [iconConfig]="contractTag.iconConfig"
        [iconUrl]="contractTag.iconUrl"
      >
      </app-usf-chip>
    </div>

    <ion-button
      class="accept-subs-btn usf-green-link-button"
      (click)="replaceEmitter.emit($event)"
    >
      {{
        (orderItem.orderItemErrorCode !== ErrorTypeEnum.CRITICAL_ERROR_1003
          ? 'i18n.productDetail.replacement.acceptSubstitute'
          : 'i18n.productDetail.replacement.acceptReplacement'
        ) | translate
      }}
    </ion-button>
  </ion-card>
</div>
